import { Action } from '@ngrx/store';
import { CoreHttpError } from './core-http.models';

export enum CoreHttpActionsType {
  SET_ERROR = '[CoreHttpAction] Set error',
  SET_PENDING = '[CoreHttpAction] Set pending',
  INCREMENT_PENDING_QUEUE = '[CoreHttpAction] Increment pending queue',
  DECREMENT_PENDING_QUEUE = '[CoreHttpAction] Decrement pending queue',
  INTERNET_NOT_WORKING = '[CoreHttpAction] Internet is not working',
  INTERNET_IS_WORKING = '[CoreHttpAction] Internet is working',
  SET_HTTP_RESPONSE_MESSAGE = '[CoreHttpAction] Set http response message',
  API_RESPONSE_ERROR = '[CoreHttpAction] Server response error',
  SET_MAINTENANCE_MODE = '[CoreHttpAction] Set maintenance mode',
  INTERNAL_SERVER_ERROR = '[CoreHttpAction] Internal Server response error'
}
export class CoreHttpActionSetError implements Action {
  readonly type = CoreHttpActionsType.SET_ERROR;

  constructor(public payload: CoreHttpError) {}
}

export class CoreHttpActionSetPending implements Action {
  readonly type = CoreHttpActionsType.SET_PENDING;

  constructor(public payload: boolean) {}
}

export class CoreHttpActionIncrementPendingQueue implements Action {
  readonly type = CoreHttpActionsType.INCREMENT_PENDING_QUEUE;

  constructor(public payload: number = 1) {}
}

export class CoreHttpActionDecrementPendingQueue implements Action {
  readonly type = CoreHttpActionsType.DECREMENT_PENDING_QUEUE;

  constructor(public payload: number = 1) {}
}

export class CoreHttpActionInternetIsWorking implements Action {
  readonly type = CoreHttpActionsType.INTERNET_IS_WORKING;

  constructor(public payload: boolean = true) {}
}

export class CoreHttpActionInternetIsNotWorking implements Action {
  readonly type = CoreHttpActionsType.INTERNET_NOT_WORKING;

  constructor(public payload: boolean = false) {}
}

export class CoreHttpActionSetHttpResponseMessage implements Action {
  readonly type = CoreHttpActionsType.SET_HTTP_RESPONSE_MESSAGE;

  constructor(public payload: string) {}
}

export class CoreHttpActionApiResponseError implements Action {
  readonly type = CoreHttpActionsType.API_RESPONSE_ERROR;
}
export class CoreHttpActionSetMaintenanceMode implements Action {
  readonly type = CoreHttpActionsType.SET_MAINTENANCE_MODE;

  constructor(public payload?: string) {}
}

export class CoreHttpActionResponseInternalError implements Action {
  readonly type = CoreHttpActionsType.INTERNAL_SERVER_ERROR;
}

export type CoreHttpActions =
  | CoreHttpActionSetError
  | CoreHttpActionSetPending
  | CoreHttpActionIncrementPendingQueue
  | CoreHttpActionDecrementPendingQueue
  | CoreHttpActionInternetIsWorking
  | CoreHttpActionInternetIsNotWorking
  | CoreHttpActionSetHttpResponseMessage
  | CoreHttpActionApiResponseError
  | CoreHttpActionSetMaintenanceMode
  | CoreHttpActionResponseInternalError;
